export default __webpack_public_path__ + "static/catalyst-logo-10ef64befd5d409c754cb347a2549729.svg";